export const electricFuelTypeFacetsNames = Object.freeze([
  'battery_range',
  'battery_charge_time',
  'battery_quick_charge_time',
  'battery_capacity'
])
